(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ChargingInfo"] = factory();
	else
		root["ChargingInfo"] = root["ChargingInfo"] || {}, root["ChargingInfo"]["index"] = factory();
})(self, () => {
return 